/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * How a Novelist publisher delivers, set per publisher by a moderator. Not an
 * ``ImportChannel``: that records how one run entered, and one delivery method yields runs of
 * several channels.
 */
export type NovelistDeliveryMethod = typeof NovelistDeliveryMethod[keyof typeof NovelistDeliveryMethod];


export const NovelistDeliveryMethod = {
  ftp: 'ftp',
} as const;
